import React from 'react';
import PropTypes from 'prop-types';
import Divider, { spacingPropTypes, spacingDefaultProps } from './Divider';

const WithDivider = ({ position, className, children, spacing }) => (
  <>
    {(position === 'top' || position === 'both') && <Divider className={className} spacing={spacing} />}
    {children}
    {(position === 'bottom' || position === 'both') && <Divider className={className} spacing={spacing} />}
  </>
);

WithDivider.propTypes = {
  position: PropTypes.oneOf(['top', 'bottom', 'both', 'none']),
  className: PropTypes.string,
  spacing: spacingPropTypes
};

WithDivider.defaultProps = {
  position: 'bottom',
  className: null,
  spacing: spacingDefaultProps
};

export default WithDivider;
